export const CBStructureFilterOptions = [
  {
    title: "Number of Institutions, Branches & Total Offices",
    fields: ["TOTAL", "BRANCHES", "OFFICES", "UNIT", "BRANCHIN"],
  },
  {
    title: "Changes in Number of Institutions",
    fields: [
      "New_Char",
      "REL_CO",
      "UNASSIST",
      "MERGERS",
      "PAID_OFF",
      "OTHER",
      "TOTAL",
    ],
  },
];

export const CBFinancialFilterOptions = [
  {
    title: "Net Income",
    fields: [
      "BANKS",
      "INTINC",
      "EINTEXP",
      "NIM",
      "NONII",
      "NONIX",
      "ELNATR",
      "ITAXR",
      "IGLSEC",
      "ITAX",
      "EXTRA",
      "NETINC",
    ],
  },
  {
    title: "Interest Income (Int Inc)",
    fields: [
      "ILNDOM",
      "ILNFOR",
      "ILS",
      "ILNLS",
      "ISC",
      "ITRADE",
      "IFREPO",
      "ICHBAL",
      "TINTINC",
      "INTINC",
    ],
  },
  {
    title: "Interest Expense (Int Inc)",
    fields: [
      "EDEPDOM",
      "EDEPFOR",
      "EDEP",
      "EFREPP",
      "NEW6_1",
      "ESUBND",
      "TOINTEXP",
      "EINTEXP",
    ],
  },
  {
    title: "Non-interest Income/Expense",
    fields: [
      "ISERCHG",
      "OONONII",
      "NONII",
      "ESAL",
      "EPREMAGG",
      "EOTHNINT",
      "NONIX",
      "NUMEMP",
    ],
  },
  {
    title: "Charge-offs, Recoveries, & Dividends",
    fields: [
      "DRLNLS",
      "CRLNLS",
      "NTLNLS",
      "EQCDIVP",
      "EQCDIVC",
      "EQCDIV",
    ],
  },
  {
    title: "Assets",
    fields: [
      "BANKS",
      "CHBAL",
      "SC",
      "LNLSGR",
      "LNATRES",
      "LNLSNET",
      "OEA",
      "BKPREM",
      "ORE",
      "INTAN",
      "NEW9_1",
      "ASSET",
    ],
  },
  {
    title: "Investment Securities",
    fields: [
      "SCUST",
      "SCAGE",
      "SCMUNI",
      "NEW10_1",
      "SCEQ",
      "SC",
      "SCMV",
      "NEW10_2",
      "NEW10_3",
    ],
  },
  {
    title: "Loans and Leases",
    fields: [
      "LNRE",
      "LNDEP",
      "LNAG",
      "LNCI",
      "LNCON",
      "LNMUNI",
      "NEW11_1",
      "LS",
      "LNLS",
      "UNINC",
      "LNATRES",
      "LNLSNET",
      "LNLSGR",
    ],
  },
  {
    title: "Real Estate Loans (R/E)",
    fields: [
      "LNRECONS",
      "LNRERES",
      "LNREMULT",
      "LNREAG",
      "LNRENRES",
      "LNREDOM",
      "LNREFOR",
      "LNRE",
    ],
  },
  {
    title: "Loans to Individuals",
    fields: [
      "LNCRCD",
      "LNCONOTH",
      "LNAUTO",
      "LNMOBILE",
      "LNSP",
      "LNCON",
    ],
  },
  {
    title: "Liabilities and Equity Capital",
    fields: [
      "BANKS",
      "DEP",
      "NEW14_1",
      "SUBND",
      "NEW14_2",
      "NEW14_3",
      "EQPP",
      "EQCS",
      "EQSUR",
      "NEW14_4",
      "EQOTHCC",
      "EQNM",
    ],
  },
  {
    title: "Deposits",
    fields: [
      "NEW15_1",
      "NEW15_2",
      "NEW15_3",
      "NEW15_4",
      "DEP",
      "DEPI",
      "DEPNI",
      "DDT",
      "NEW15_5",
      "NTRTIME",
      "NEW15_7",
      "TRN",
      "NTR",
      "DEPNIFOR",
      "DEPIFOR",
      "DEPFOR",
    ],
  },
  {
    title: "Interest Earning Asset and Interest Bearing Liabilities",
    fields: [
      "CHBALI",
      "SC",
      "LNLSNET",
      "FREPO",
      "TRADE",
      "INTBAST",
      "DEPI",
      "FREPP",
      "MTGLS",
      "NEW16_1",
      "SUBND",
      "INTBLIB",
    ],
  },
  {
    title: "Past Due (P/D) & Non-accrual Loans & Leases",
    fields: [
      "P3LNLS",
      "P9LNLS",
      "TPD",
      "NALNLS",
      "NCLNLS",
    ],
  },
];


export const SIStructureFilterOptions = [
    {
      title:"Number of Institutions by Regulatory Agent and Insurance Fund (National Only)",
      fields: [
        "FD_SAIF",
        "FD_BIF",
        "TOT_FDIC",
        "OT_SAIF",
        "OT_BIF",
        "TOT_OTS",
        "TOT_SAVE",
        "CONS",
      ],
    },
    {
      title: "Changes in Number of Institutions(National Only)",
      fields: [
        "newcount",
        "alsonew",
        "chrtrest",
        "chartoth",
        "combos",
        "tomerg",
        "comboass",
        "tofail",
        "liqasstd",
        "tortc",
        "liqunass",
        "tochrt",
        "MISSADJ",
        "SAVINGS",
      ],
    },
];

export const SIFinancialFilterOptions = [
  {
    title: "Net Income",
    fields: [
      "COUNT",
      "INTINC",
      "EINTEXP",
      "NIM",
      "NONII",
      "NONIX",
      "ELNATR",
      "PTXNOINC",
      "IGLSEC",
      "ITAX",
      "EXTRA",
      "NETINC",
    ],
  },
  {
    title: "Interest Income (Int Inc)",
    fields: [
      "ILNS",
      "ILS",
      "ILNLS",
      "ISC",
      "ITRADE",
      "IFREPO",
      "ICHBAL",
      "TINTINC",
      "INTINC",
    ],
  },
  {
    title: "Interest Expense (Int Inc)",
    fields: [
      "EDEP",
      "EFREPP",
      "OTHBORR",
      "ESUBND",
      "EFHLBADV",
      "TOINTEXP",
      "EINTEXP",
    ],
  },
  {
    title: "Non-interest Income/Expense",
    fields: [
      "IFEE",
      "OONONII",
      "NONII",
      "ESAL",
      "EPREMAGG",
      "EOTHNINT",
      "NONIX",
      "EAMINTAN",
      "NUMEMP",
    ],
  },
  {
    title: "Charge-offs, Recoveries, & Dividends",
    fields: [
      "DRLNLS",
      "CRLNLS",
      "NCHGREC",
      "EQCDIVP",
      "EQCDIVC",
      "EQCDIV",
    ],
  },
  {
    title: "Assets",
    fields: [
      "COUNT",
      "CHBAL",
      "SC",
      "LNLSGR",
      "LNATRES",
      "LNLSNET",
      "OEA",
      "BKPREM",
      "ORET",
      "INTAN",
      "OTHASST",
      "ASSET",
    ],
  },
  {
    title: "Investment Securities",
    fields: [
      "SCUST",
      "SCAGE",
      "SCUS",
      "SCMUNI",
      "CORPBNDS",
      "SCEQ",
      "SCRES",
      "TRADES",
      "SC",
      "SCMTGBK",
    ],
  },
  {
    title: "Loans and Leases",
    fields: [
      "LNRE",
      "LNDEP",
      "LNAG",
      "LNCI",
      "LNCON",
      "LNMUNI",
      "ALLOTHER",
      "LS",
      "UNINC",
      "OTLNCNTA",
      "LNLSGR",
      "LNATRES",
      "LNLSNET",
    ],
  },
  {
    title: "Real Estate Loans (R/E)",
    fields: [
      "LNRECONS",
      "LNRERES",
      "LNREMULT",
      "LNRENRES",
      "LNRE",
      "LNRELOC",
      "LNRESRE",
    ],
  },
  {
    title: "Loans to Individuals",
    fields: [
      "LNCRCD",
      "LNCONOT1",
      "LNALLOTH",
      "LNCON",
    ],
  },
  {
    title: "Liabilities and Equity Capital",
    fields: [
      "COUNT",
      "DEP",
      "OTHNBORR",
      "SUBLLPF",
      "OTHLIAB",
      "LIAB",
      "EQPP",
      "EQCS",
      "EQSUR",
      "EQUPTOT",
      "EQNWCERT",
      "EQNM",
      "LIABEQ",
    ],
  },
  {
    title: "Deposits",
    fields: [
      "DEP",
      "DDT",
      "NTRTMLG",
      "IRAKEOGH",
      "BRO",
    ],
  },
  {
    title: "Interest Earning Asset and Interest Bearing Liabilities",
    fields: [
      "CHBALI",
      "SC",
      "LNLSNET",
      "FREPO",
      "TRADE",
      "INTBAST",
      "DEPI",
      "FREPP",
      "OTHBFHLB",
      "OINTBOR",
      "SUBLLPF",
      "EQNWCERT",
      "INTBLIB",
    ],
  },
  {
    title: "Past Due (P/D) & Non-accrual Loans & Leases",
    fields: [
      "P3LNLS",
      "P9LNLS",
      "TPD",
      "NALNLS",
      "NCLNLS",
    ],
  },
];
